import angular from 'angular';

export default function adjustCalendarHeaderWidth($window) {
  'ngInject';

  const windowElement = angular.element($window);

  return {
    restrict: 'A',
    link($scope, $element, $attrs) {
      windowElement.on('resize', resizeHandler);
      $scope.$on('$destroy', () => {
        windowElement.off('resize', resizeHandler);
      });

      let widthFirstChange = false;
      $attrs.$observe('adjustCalendarHeaderWidth', () => {
        if (!widthFirstChange) {
          widthFirstChange = true;
        } else {
          $scope.$$postDigest(resizeHandler);
        }
      });

      const unobserve = $attrs.$observe('adjustCalendarHeaderWidthTrigger', (isLoading) => {
        if (isLoading === 'false') {
          $scope.$$postDigest(resizeHandler);
          unobserve();
        }
      });

      $scope.$watch($attrs.adjustCalendarHeaderWidthEnabled, resizeHandler);

      function resizeHandler() {
        if ($scope.$eval($attrs.adjustCalendarHeaderWidthEnabled) === false) {
          $element.css('width', '');
          return;
        }

        const sidebar = document.getElementById('shifts-sidebar-spacer');
        const content = document.getElementById('shifts-main-container');

        if (sidebar || content) {
          let targetWidth = 0;

          if (sidebar) {
            targetWidth += sidebar.getBoundingClientRect().width;
          }

          if (content) {
            targetWidth += content.getBoundingClientRect().width;
          }

          $element.css('width', `${targetWidth}px`);
        }
      }
    },
  };
}
